import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import endpoint from '@constants/apipath'
import constant from '@constants/constant'

export const state = {
  // hmdaErrors: [],
  filesList: [],
  filesUploadedList: [],
  filesErrorList: [],
  projectSummary: {},
  projectErrorSummary: [],
  hmdaConfigData: [],
}

export const getters = {
  // Errors: (state) => state.hmdaErrors
  filesUploadedList: (state) => state.filesUploadedList,
  filesErrorList: (state) => state.filesErrorList,
  projectSummary: (state) => state.projectSummary,
  projectErrorSummary: (state) => state.projectErrorSummary,
  // hmdaConfigData: (state) => state.hmdaConfigData,
}

export const mutations = {
  SET_FILES_LIST(state, value) {
    state.filesList = value
  },

  SET_FILES_UPLOADED_LIST(state, value) {
    state.filesUploadedList = value
  },

  SET_FILES_ERROR_LIST(state, value) {
    state.filesErrorList = value
  },

  SET_PROJECT_SUMMARY(state, value) {
    state.projectSummary = value
  },

  SET_PROJECT_ERROR_SUMMARY(state, value) {
    state.projectErrorSummary = value
  },
  SET_HMDA_CONFIG_DATA(state, value) {
    state.hmdaConfigData = value
  },
}

export const actions = {
  // addForUrl(key, value) {
  //   return value === null || value === undefined
  //     ? ''
  //     : `&${key}=${encodeURIComponent(value)}`
  // },
  // init({ state, dispatch }) {},

  async getOrCreateContainer({ state }, { projectId }) {
    // const CONTAINER_NAME = `hmdacontainer${projectId}`
    // do the azure stuffs

    const containerClient = {}

    return containerClient
  },

  fetchAttrComment({ state, dispatch }, { larDetailId, attrId }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getAttrComments}/${larDetailId}/${attrId}`,
        {
          headers: setHeaders(),
          validateStatus: (status) => status === 200,
        }
      )
      .then((resp) => {
        return resp.data
      })
      .catch((err) => {
        __showError(err.response.data.message)
      })
  },

  fetchLoanHeader({ state, dispatch }, loanId) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getLoanHeader}/${loanId}`,
        {
          headers: setHeaders(),
          validateStatus: (status) => status === 200,
        }
      )
      .then((resp) => {
        return resp.data
      })
      .catch((err) => {
        __showError(err.response.data.message)
      })
  },

  fetchLoanDetail({ state, dispatch }, { loanQuery, isNextPrevReq }) {
    loanQuery.nextLoanNumber = isNextPrevReq ? loanQuery.nextLoanNumber : 0
    loanQuery.previousLoanNumber = isNextPrevReq
      ? loanQuery.previousLoanNumber
      : 0
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getLoanDetail}?LoanId=${loanQuery.LoanId}&PageSize=${loanQuery.PageSize}&PageNumber=${loanQuery.PageNumber}&ProjectId=${loanQuery.ProjectId}&SortBy=${loanQuery.SortBy}&SortDirection=${loanQuery.SortDirection}&FromDate=${loanQuery.FromDate}&ToDate=${loanQuery.ToDate}&LoanType=${loanQuery.LoanType}&NextLoanId=${loanQuery.nextLoanNumber}&PreviousLoanId=${loanQuery.previousLoanNumber}`,
        {
          headers: setHeaders(),
          validateStatus: (status) => status === 200,
        }
      )
      .then((resp) => {
        const loanQuery = JSON.parse(localStorage.getItem('loanQuery'))
        loanQuery.PageNumber = resp.data ? resp.data.pageNumber : 1
        loanQuery.LoanId = resp.data ? resp.data.larDetailId : 0
        loanQuery.nextLoanNumber = resp.data ? resp.data.nextLoanNumber : 0
        loanQuery.previousLoanNumber = resp.data
          ? resp.data.previousLoanNumber
          : 0
        localStorage.setItem('loanQuery', JSON.stringify(loanQuery))
        return resp
      })
      .catch((err) => {
        __showError(err.response.data.message)
      })
  },

  async uploadLoanFiles({ dispatch }, { file, projectId }) {
    return dispatch('uploadToBackend', { file, projectId })
  },

  async uploadToBackend({ dispatch }, { file, projectId }) {

    const user = store.state.auth.currentUser.userInfo

    let customerId = 0
    let userId = 0

    await dispatch('getSelectedCustomer').then(
      (res) => (customerId = res.value)
    )
    await dispatch('getSelectedUser').then((res) => (userId = res.value))

    const finalCustomerId = customerId > 0 ? customerId : user.customerId
    const finalUserId = userId > 0 ? userId : user.userId

    let rObj = { message: 'Upload failed' }

    try {
      const formData = new FormData()
      formData.append('ProjectId', projectId)
      formData.append('CustomerId', finalCustomerId)
      formData.append('UserId', finalUserId)
      formData.append('File', file, file.name)

      const headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: axios.defaults.headers.common.Authorization,
      }
      
      const response = await axios.post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.uploadFile}`,
        formData,
        {
          headers: {
            Accept: '*/*',
            headers: headers
          },
        }
      )

      rObj = {
        isSuccess: true,
        data: response.data,
        message: `File upload completed: ${file.name}`,
      }
    } catch (error) {
      let msg = 'Upload failed'

      if (error && error.response) {
        const status = error.response.status
        const data = error.response.data

        if (data && data.message) msg = data.message
        else if (data) msg = data
        // ❗ Only treat 409 as a failure state
        if (status === 409) {
          rObj = {
            isSuccess: false,
            message: msg,
          }
          return rObj
        }

        // other HTTP errors → message only
        rObj.message = msg
        return rObj
      }

      if (error && error.message) {
        msg = error.message
      }

      rObj.message = msg
    }

    dispatch(
      'toaster/setAlert',
      {
        title: `Upload ${rObj.isSuccess ? 'Success' : 'Error'}`,
        msg: rObj.message,
        variant: rObj.isSuccess
          ? constant.AlertTypes.Success
          : constant.AlertTypes.Error,
      },
      { root: true }
    )

    return rObj
  },

  // projects
  createProject({ state, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.createProject}`,
          payload,
          {
            headers: setHeaders(),
            validateStatus: (status) => status === 200,
          }
        )
        .then((resp) => {
          resolve(resp.data)
        })
        .catch((err) => {
          __showError(err.response.data.message)
          reject(err)
        })
    })
  },

  fetchProjectsList(
    { commit },
    { PageSize, PageNumber, SearchKey, SearchValue, customerId }
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getProjects}?PageSize=${PageSize}&PageNumber=${PageNumber}&SearchKey=${SearchKey}&SearchValue=${SearchValue}&SelectedCustomer=${customerId}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured')
      })
  },

  // project details
  fetchProjectSummary({ commit }, { projectId }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getProjectSummary}?projectId=${projectId}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        commit('SET_PROJECT_SUMMARY', response.data)
        return response
      })
      .catch(() => {
        __showError()
        commit('SET_PROJECT_SUMMARY', {})
      })
  },

  fetchProjectErrorSummary({ commit }, { projectId }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getProjectErrorSummary}/${projectId}/errorSummary`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        commit('SET_PROJECT_ERROR_SUMMARY', response ? response.data || [] : [])
        return response
      })
      .catch(() => {
        __showError()
      })
  },

  generateLAR({ commit }, options) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.generateLAR}`,
        options,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((resp) => {
        return resp
      })
      .catch(() => {
        __showError()
      })
  },

  approveLARDownload({ commit }, larId) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.approveLARDownload}/${larId}`,
        null,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((resp) => {
        if (resp && resp.data === true) {
          __showSuccess('Approved Successfully')
          return resp.data
        } else {
          __showError('Approval Failed')
        }
      })
      .catch(() => {
        __showError()
      })
  },

  downloadLAR({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.downloadLAR}`,
        payload,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((resp) => {
        return resp
      })
      .catch(() => {
        __showError()
      })
  },

  async fetchProjectFiles({ commit, dispatch }, { projectId }) {
    let customerId
    const user = store.state.auth.currentUser.userInfo
    await dispatch('getSelectedCustomer').then((res) => {
      const cid = res.value
      customerId = cid > 0 ? res.value : user.customerId
    })
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getFilesUploadedList}/${customerId}/ViewProject/${projectId}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        commit('SET_FILES_UPLOADED_LIST', response.data.uploadedFiles)
        commit('SET_FILES_ERROR_LIST', response.data.errorFiles)
        return response
      })
      .catch(() => {
        __showError()
        commit('SET_FILES_UPLOADED_LIST', [])
        commit('SET_FILES_ERROR_LIST', [])
      })
  },

  fetchActivityLogs({ commit }, { ProjectId, PageSize, PageNumber }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getProjectActivityLogs}?PageSize=${PageSize}&PageNumber=${PageNumber}&ProjectId=${ProjectId}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured while fetching logs')
      })
  },

  fetchProjectNewLoans(
    { commit },
    { ProjectId, PageSize, PageNumber, SortBy, SortDirection, FromDate, ToDate }
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getProjectNewLoans}?PageSize=${PageSize}&PageNumber=${PageNumber}&projectId=${ProjectId}&SortBy=${SortBy}&SortDirection=${SortDirection}&FromDate=${FromDate}&ToDate=${ToDate}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured while fetching new loans')
      })
  },

  fetchProjectPassedLoans(
    { commit },
    { ProjectId, PageSize, PageNumber, SortBy, SortDirection, FromDate, ToDate }
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getProjectPassedLoans}?PageSize=${PageSize}&PageNumber=${PageNumber}&projectId=${ProjectId}&SortBy=${SortBy}&SortDirection=${SortDirection}&FromDate=${FromDate}&ToDate=${ToDate}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured while fetching passed loans')
      })
  },

  fetchProjectFailedLoans(
    { commit },
    { ProjectId, PageSize, PageNumber, SortBy, SortDirection, FromDate, ToDate }
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getProjectFailedLoans}?PageSize=${PageSize}&PageNumber=${PageNumber}&projectId=${ProjectId}&SortBy=${SortBy}&SortDirection=${SortDirection}&FromDate=${FromDate}&ToDate=${ToDate}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured while fetching failed loans')
      })
  },

  fetchProjectDeletedLoans(
    { commit },
    { ProjectId, PageSize, PageNumber, SortBy, SortDirection }
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getProjectDeleteLoans}?PageSize=${PageSize}&PageNumber=${PageNumber}&projectId=${ProjectId}&SortBy=${SortBy}&SortDirection=${SortDirection}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured while fetching deleted loans')
      })
  },

  deleteLoanSingle({ commit }, { loanDetailId }) {
    return axios
      .delete(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.deleteLoan}/${loanDetailId}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured while delete loan')
      })
  },

  deleteLoanBatch({ commit }, { loanDetailIds, reason }) {
    let mappedArray = {
      Ids: loanDetailIds,
      Reason: reason,
    }
    return axios
      .delete(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.deleteLoanBatch}`,
        {
          headers: setHeaders(),
          validateStatus: (status) => status === 200,
          data: mappedArray,
        }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured while delete loan batch')
      })
  },

  fetchProjectDatatypeLoans(
    { commit },
    { ProjectId, PageSize, PageNumber, SortBy, SortDirection, FromDate, ToDate }
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getProjectDatatypeLoans}?PageSize=${PageSize}&PageNumber=${PageNumber}&projectId=${ProjectId}&SortBy=${SortBy}&SortDirection=${SortDirection}&FromDate=${FromDate}&ToDate=${ToDate}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError(
          'An unexpected error occured while fetching datatype mismatch loans '
        )
      })
  },

  fetchUploadedFilesErrorList({ commit }, { Payload, LarId }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getUploadedFilesErrorList}/${LarId}`,
        Payload,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured')
      })
  },

  postLoan({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.postLoan}`,
        payload,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        __showSuccess(response.data.message)
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured')
      })
  },

  fetchLARSummary({ commit }, { pageNo, pageSize, customerId }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getLARSummary}?PageSize=${pageSize}&PageNumber=${pageNo}&SelectedCustomer=${customerId}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response.data
      })
      .catch(() => __showError('An unexpected error occured'))
  },

  postRunRules({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.runRules}`,
        payload,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        response.data.responseStatus === 1
          ? __showSuccess(response.data.message)
          : __showError(response.data.message)
        return response
      })
      .catch(() => __showError('An unexpected error occured'))
  },

  actionOnDuplicateLoans({ commit }, { Payload }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.actionOnDuplicateFiles}`,
        Payload,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        response.data.responseStatus === 1
          ? __showSuccess(response.data.message)
          : __showError(response.data.message)
        return response
      })
      .catch(() => __showError('An unexpected error occured'))
  },

  downloadErrorListCsv({ commit }, { LarFileId }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.downloadErrorList}/${LarFileId}/download`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured while downloading CSV file')
      })
  },

  downloadFailedLoansCsv({ commit }, { larIds }) {
    let payload = { LarsIds: larIds }
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.downloadFailedLoansCsv}`,
        payload,
        {
          headers: setHeaders(),
          validateStatus: (status) => status === 200,
        }
      )
      .then((response) => {
        return response
      })
      .catch(() => __showError('An unexpected error occured'))
  },

  downloadManagementAndOperationReport(
    { commit, dispatch, getters },
    data = {}
  ) {
    var url =
      appConfig.apiEndPoint +
      endpoint.hmdaApiPath.downloadManagementAndOperationCsv
    return axios
      .post(url, data, {
        headers: setHeaders(),
        validateStatus: (status) => status === 200,
      })
      .then((response) => {
        return response
      })
      .catch(() =>
        __showError(
          'An unexpected error occured while downloading Management And Operation report'
        )
      )
  },

  fetchProjectDashboard({ commit }, { ProjectId }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getProjectDashboard}/${ProjectId}/Summary`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured')
      })
  },

  updateProject({ commit }, { Payload }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.updateProject}`,
        Payload,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        response.data.responseStatus === 1
          ? __showSuccess(response.data.message)
          : __showError(response.data.message)
        return response
      })
      .catch(() => {
        __showError(
          'An unexpected error occured while changing the project status'
        )
      })
  },

  // rules
  fetchRulesList({ commit }, { PageSize, PageNumber, ruleType }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getRules}?PageSize=${PageSize}&PageNumber=${PageNumber}&ruleType=${ruleType}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError('An unexpected error occured')
      })
  },

  setSelectedCustomer({ commit }, { customer }) {
    window.localStorage.setItem('selectedCustomer', JSON.stringify(customer))
  },

  setSelectedUser({ commit }, { user }) {
    window.localStorage.setItem('selectedUser', JSON.stringify(user))
  },

  getSelectedCustomer({ commit }) {
    let customer =
      JSON.parse(window.localStorage.getItem('selectedCustomer')) || {}
    return customer
  },

  getSelectedUser({ commit }) {
    let user = JSON.parse(window.localStorage.getItem('selectedUser')) || {}
    return user
  },

  saveFileUploadActivity({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.saveFileUploadActivity}`,
        payload,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((resp) => {
        return resp
      })
      .catch(() => {
        __showError()
      })
  },

  fetchAllHmdaCustomers({ commit }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getAllHmdaCustomers}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response.data
      })
      .catch(() => {
        __showError()
      })
  },

  fetchAllCustomerUsers({ commit }, { customerId }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getAllCustomerUsers}/${customerId}/order.hmda`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError()
      })
  },

  saveLei({ commit }, { payload }) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.saveLei}`,
        payload,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((resp) => {
        return resp
      })
      .catch(() => {
        __showError()
      })
  },

  fetchLei({ commit }, { customerId }) {
    window.localStorage.setItem('hmdacustomerid', customerId)
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getLei}?customerId=${customerId}`,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError()
      })
  },
  setHMDAConfigData({ commit }, value) {
    commit('SET_HMDA_CONFIG_DATA', value)
  },
  getRateSpreadValue({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getRateSpreadValue}`,
        payload,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError()
      })
  },
  getGeoCodeValue({ commit }, payload) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getGeoCodeValue}`,
        payload,
        { headers: setHeaders(), validateStatus: (status) => status === 200 }
      )
      .then((response) => {
        return response
      })
      .catch(() => {
        __showError()
      })
  },
  fetchULIComment({ state, dispatch }, { larDetailId }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.hmdaApiPath.getULIComments}/${larDetailId}`,
        {
          headers: setHeaders(),
          validateStatus: (status) => status === 200,
        }
      )
      .then((resp) => {
        return resp.data
      })
      .catch((err) => {
        __showError(err.response.data.message)
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}

function __showError(msg) {
  store.dispatch(
    'toaster/setAlert',
    {
      title: 'Error',
      msg: msg || 'An unexpected error occured while processing data (0x33)',
      variant: constant.AlertTypes.Error,
    },
    { root: true }
  )
}

function __showSuccess(msg) {
  store.dispatch(
    'toaster/setAlert',
    {
      title: 'Success',
      msg: msg,
      variant: constant.AlertTypes.Success,
    },
    { root: true }
  )
}
